 $(document).ready(function(){

// Start Centermode code by sandhya
$('.feature-product-at-home').slick({
  dots: false,
  arrows: true,
  prevArrow: '<button type="button" class="slick-prev slick-arrow" style=""><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
  nextArrow: '<button type="button" class="slick-next slick-arrow" style=""><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint:749,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '70px',
        arrows: true,
        dots: false
      }
    }
  ]
});
   
function applyTransformations() {
  if (window.matchMedia("(max-width: 749px)").matches) {
    $('.feature-product-at-home .slick-slide').each(function() {
      if ($(this).hasClass('slick-center')) {
        $(this).css('transform', 'scale(1)');
      } else {
        $(this).css('transform', 'scale(0.9)');
      }
    });
  } 
}
$(window).on('load', function() {
  applyTransformations();
});
$('.feature-product-at-home').on('afterChange', function(event, slick, currentSlide) {
  applyTransformations();
});
$(window).on('resize', function() {
  applyTransformations();
});

   
// End Centermode code by sandhya

 $('.cstm_product_slider').slick({
    dots: false,
    arrow: true,
    prevArrow: '<button type="button" class="slick-prev slick-arrow" style=""><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>', 
    nextArrow: '<button type="button" class="slick-next slick-arrow" style=""><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });

 if($(window).width()>749){
  /*Desktop Thumbnails*/ 
$('.product--no_cstm .thumbnail-list').slick({
    dots: false,
    arrow: true,
    vertical: true,
    nextArrow: '<button type="button" class="slick-next"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>', 
    prevArrow: '<button type="button" class="slick-prev"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
    slidesToShow: 5,
    slidesToScroll: 1,
    focusOnSelect: true,
   infinite:true,
  watchCss:true,
    asNavFor: '.product--no_cstm .product__media-list',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      }
    ]
  });
  $('.product--no_cstm .product__media-list').slick({
    dots: false,
    arrow: true,
    nextArrow: '<button type="button" class="slick-next"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>', 
    prevArrow: '<button type="button" class="slick-prev"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
    slidesToShow: 1,
    slidesToScroll: 1,
     focusOnSelect: true,
     asNavFor: '.product--no_cstm .thumbnail-list'
  });
  
  /*End Desktop Thumbnails*/ 
  }

$(".size_name").click(function(){
if(!$(this).hasClass('active')){
if($(this).hasClass('in_size_table')){
  $('.size-changetd').each(function(){
    var innerTxt = parseFloat($(this).text().trim());
    var multiVal = innerTxt/2.54;
    $(this).text(parseFloat(multiVal).toFixed(1));
  })
}else{
   console.log('sssss');
  $('.size-changetd').each(function(){
    var innerTxt = parseFloat($(this).text().trim());
    var multiVal = 2.54*innerTxt;
    $(this).text(parseFloat(multiVal).toFixed(1));
  })
}
  $(".size_name").removeClass('active');
$(this).addClass('active');
}
});
  
});

// ============================legal report================================
 $(document).ready(function(){
    $('.accord-head').click(function(){
      $(this).parent().find('.accord-body').toggleClass('showReport');
      $('.accord-head').not(this).parent().find('.accord-body').removeClass('showReport');
      $(this).toggleClass('clicked');
      $('.accord-head').not(this).removeClass('clicked');
    });

 // open a specific page when clicking on a navigation menu item    
    $('.accord-head.first').click(function(event){
        // Prevent the default behavior of the link
        event.preventDefault();
        // Navigate to the desired page
        window.location.href = '/pages/report-overview';
    });    
  });
// ============================legal report================================
$(document).ready(function() {
     // -------------------Banner Click ----------------------------
    document.querySelectorAll(".Banner_Click").forEach((item) => {
        item.parentElement.addEventListener('click', function() {
         let tgthref =  item.getAttribute("href")
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({'event': 'Banner_Click',
                                'url':tgthref});
            } else {
                console.warn('dataLayer is not defined');
            }
        });
    });

  
  // -----------------------------Spring Essentials Banner, Occasion Ready Looks, Featured Shops-----------------------------
  const springBanner = (eventName,bannerLink)=>{
     dataLayer.push(
       {
        'event': eventName,
        'url':bannerLink
       });
  }
  const springBannerEl = document.querySelectorAll(".slider-mobile-gutter li");
  const eventArr = ["Summer Hill banner","Blue Ink Banner","Schiffli banner","Pastel pret","Work Occasion Banner","Casual Occasion Banner","Celebration Occasion Banner","Shades of spring","Folksong"];
  for(let i=0;i<springBannerEl.length;i++){
    const item = springBannerEl[i];
    item.addEventListener('click', function() {
      const bannerUrl = item.querySelector('.card-wrapper').href;
      const eventName = eventArr[i];
      springBanner(eventName,bannerUrl);
    })
  }

    // -------------------Celebrity Banner ----------------------------
    document.querySelector(".main_image_section a")?.addEventListener('click', function() {
         let tgthref =  document.querySelector(".main_image_section a").getAttribute("href")
                dataLayer.push({'event': 'Celebrity Banner',
                                'url':tgthref});
        });
  
});


$(document).on("click", '[has-show-quick-buy] a', function(e) {
  e.preventDefault();
  var variantId = $(this).data("variant-id");

  $(this).closest('li').find('add-to-cart').attr('data-variant-id', variantId);
  $(this).closest('li').find('[has-show-quick-buy] a').removeClass('active-size');
  $(this).addClass('active-size');
  console.log("Variant set on Add to Cart:", variantId);
});




    document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth < 750) {
    document
      .querySelectorAll('.product__media-list.slider--mobile')
      .forEach(el => {
        el.classList.remove('slider', 'slider--mobile');
      });
  }
});

$(document).ready(function () {

  if ($(window).width() < 750) {

    const $gallery = $('.product__media-list');

    if ($gallery.length && !$gallery.hasClass('slick-initialized')) {
      $gallery.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true, 
        arrows: true,
        nextArrow:
        '<button type="button" class="slick-next"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
      prevArrow:
        '<button type="button" class="slick-prev"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
      });
    }
  }

});
